import React from 'react';

const SunsetIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 6.000000)'>
        <path d='M1,10 L5,10 C5,7.23857625 7.23857625,5 10,5 C12.7614237,5 15,7.23857625 15,10 L19,10 C19.5522847,10 20,10.4477153 20,11 C20,11.5522847 19.5522847,12 19,12 L1,12 C0.44771525,12 0,11.5522847 0,11 C0,10.4477153 0.44771525,10 1,10 M3,14 L17,14 C17.5522847,14 18,14.4477153 18,15 C18,15.5522847 17.5522847,16 17,16 L3,16 C2.44771525,16 2,15.5522847 2,15 C2,14.4477153 2.44771525,14 3,14 M15,18 C15.5522847,18 16,18.4477153 16,19 C16,19.5522847 15.5522847,20 15,20 L5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.4477153 4.44771525,18 5,18 L15,18 M13,10 C13,8.34314575 11.6568542,7 10,7 C8.34314575,7 7,8.34314575 7,10 L13,10 M10,0 L12.39,3.42 C11.65,3.15 10.84,3 10,3 C9.16,3 8.35,3.15 7.61,3.42 L10,0 M1.34,5 L5.5,4.65 C4.9,5.16 4.36,5.78 3.94,6.5 C3.5,7.24 3.25,8 3.11,8.79 L1.34,5 M18.65,5 L16.88,8.79 C16.74,8 16.47,7.23 16.05,6.5 C15.63,5.78 15.1,5.15 14.5,4.64 L18.65,5 Z' />
      </g>
    </g>
  </svg>
);

export default SunsetIcon;
